import { createContext, useContext, useEffect, useState } from "react";
import useDataPersistent from "../hooks/usedataPersistant";

const WasserBProgressContext = createContext({});

export const WasserBProgressContextProvider = ({ children }) => {
    const markersIds = [
        "wasserB-lola-message-icon", "wasserB-lola-message-1", "wasserB-lola-message-2",
        "wasserB-icons-sprinkler", "wasserB-icons-waterpistol", "wasserB-icons-boy", "wasserB-icons-waterDrum", "wasserB-icons-waterKettle", "wasserB-icons-paddlePool"

    ];
    const [clickedMarkers, setClickedMarkers] = useDataPersistent(
        "clickedMarkersWasserB",
        []);

    const [progress, setProgress] = useDataPersistent("progressWasserB", 0);
    useEffect(() => {
        const validMarkers = clickedMarkers.filter(marker =>
            markersIds.includes(marker)
        );
        const uniqueMarkers = [...new Set(validMarkers)]; // Remove duplicates
        const currentProgress = uniqueMarkers.length / markersIds.length;
        setProgress(currentProgress);
    }, [clickedMarkers, markersIds.length, setProgress]);

    const countPercentage = (id) => {
        if (!markersIds.includes(id)) {
            return progress; // Return current progress if invalid ID
        }

        // Update clicked markers (will trigger progress calculation via useEffect)
        setClickedMarkers(prev => {
            const newMarkers = [...prev, id];
            return [...new Set(newMarkers)]; // Ensure no duplicates
        });

        return progress; // Progress will be updated by the useEffect
    };

    return (
        <WasserBProgressContext.Provider value={{ countPercentage, clickedMarkers, progress }}>
            {children}
        </WasserBProgressContext.Provider>
    );
};

export const usewasserBProgress = () => {
    return useContext(WasserBProgressContext);
};
